"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.inList = exports.CompatibleInListConfig = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
class CompatibleInListConfig {
    config;
    operation;
    // Private instance properties allow typescript to ensure that an instance of
    // this class is being used.
    constructor(config) {
        this.config = config;
        this.operation = config.operation;
    }
    ensureCompatibility = (loanTape) => {
        const { field, type, list } = this.config;
        const invalidListValue = list.find((value) => typeof value !== type);
        (0, common_1.finleyAssert)(!invalidListValue, `list value ${invalidListValue} has invalid type ${typeof invalidListValue}. Expected type ${type}`);
        const invalidRecord = _.find(loanTape, (record) => {
            const value = (0, utils_1.getFieldValue)({ loanTape: record, field });
            return !_.isNil(value) && typeof value !== type;
        });
        (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({
            invalidRecord,
            field,
            type,
            operationType: this.operation,
        }));
    };
    static create = (config, loanTape) => {
        const obj = new CompatibleInListConfig(config);
        obj.ensureCompatibility(loanTape);
        return obj;
    };
}
exports.CompatibleInListConfig = CompatibleInListConfig;
/*
 * Selects all loanTapes where the value of a field is
 * contained in a list of values
 *
 * example config:
 * {
 *    field: 'industry',
 *    type: 'string',
 *    operator: 'inList',
 *    list: ['hotels', 'restaurants', 'leisure'],
 * }
 *
 */
const inList = ({ config: { field, list, operation }, }) => (loanTapeRecords) => {
    const targetKeySet = list.reduce((keySet, value) => keySet.add((0, utils_1.toLowerIfString)(value)), new Set());
    const filteredTape = loanTapeRecords.filter((loanTape) => {
        const lowerCaseValue = (0, utils_1.toLowerIfString)((0, utils_1.getFieldValue)({ field, loanTape }));
        const isInList = targetKeySet.has(lowerCaseValue);
        return operation === 'inList' ? isInList : !isInList;
    });
    return filteredTape;
};
exports.inList = inList;
//# sourceMappingURL=inList.js.map